import React from 'react'
import ReleaseInfoComponent from '../components/ReleaseInfoComponent.js'
import packageJson from '../../package.json';

import './Information.css'
// -----------------------------------------------------------------------------

export default class InformationPage extends React.Component {

  // -----------------------

  render() {

    return (
      <div className={"informationScreen-Container"}>
        <div className={"informationScreen"}>
          <div>
            <h1 className={"informationScreen-Title"}><strong>{packageJson.name}</strong></h1>
          </div>

          <div className={"informationScreen-ProjectDescription"}>
            <p>
              {packageJson.name} is a web application developed by the National Research Council (NRC).
            </p>
          </div>

          <div className={"informationScreen-CreditSection"}>
            <div className={"informationScreen-CreditTitle"}>
              Credit
            </div>
            <div className={"informationScreen-CreditText"}>
              NRC Canada / CNRC<br/>
              Simulation and Digital Health / Simulation en santé numérique<br/>
              Medical devices / Dispositifs médicaux
            </div>
          </div>

        </div>
        <div className={"informationScreen-ReleaseInfo footer"}>
          <ReleaseInfoComponent />
        </div>
      </div>
    );
  }
}

// -----------------------------------------------------------------------------
